module.exports = __webpack_public_path__ + "img/RescueHaus.dde94d70.jpg";